export function getNumberWithOrdinal(n: number) {
    const s = ["th", "st", "nd", "rd"],
        v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function extractQuestionNumber(name: string | undefined) {
    return parseInt(name?.match(/\d+/)?.[0] || '0')
}
